import { BaseModel } from "./common.model";
import { EcosystemServiceModel, ValuationMethod } from "./ecosystem-service.model";
import { ExerciseModel } from "./exercise.model";


export interface ExerciseEcoserviceModel extends BaseModel {
  status: 'draft' | 'disable' | 'enable';
  exercise: ExerciseModel.Ref;
  ecoservice: { id: string; pos: number }; // referencia del ecosystem service
  valuationMethod: ValuationMethod;
  physical: ExerciseEcoserviceModel.Physical;
  monetary: ExerciseEcoserviceModel.Monetary;
  assetType: EcosystemServiceModel.AssetType;
}


export namespace ExerciseEcoserviceModel {

  export const create = (exercise: ExerciseModel, ecoservice: Partial<EcosystemServiceModel>): ExerciseEcoserviceModel => {
    return {
      status: 'draft',
      exercise: ExerciseModel.genRef(exercise),
      ecoservice: { id: ecoservice.id, pos: ecoservice.pos }, // referencia del ecosystem service
      // valuationMethodId: (ecoservice.valuationMethods && ecoservice.valuationMethods.length) ? ecoservice.valuationMethods[0].id: null,
      valuationMethod: null,
      physical: null,
      monetary: null,
      assetType: ecoservice.assetType,
    }
  }


  export const ExpectedProjectionKeys = ['up', 'stable', 'down'];
  export type ExpectedProjection = typeof ExpectedProjectionKeys[number];
  export interface PhysicalNormalized {
    min: number;
    max: number;
    value: number;
  }

  export interface Physical {
    exploitedHa:number;
    exploitedAssets: number;
    totalHa: number;
    totalAssets: number;
    expectedProjection?: ExpectedProjection;
    normalized?: PhysicalNormalized;
    note: string;
  }

  export interface UncertaintyLevel {
    id: string,
    value: number,
    selectable: boolean,
  }

  export const UNCERTAINTY_LEVEL_RANGES: Array<UncertaintyLevel> = [
    { id: 'unknown', value: 0, selectable: false },
    { id: 'very-high', value: 0.2, selectable: true },
    { id: 'high', value: 0.4, selectable: true },
    { id: 'moderate', value: 0.6, selectable: true },
    { id: 'low', value: 0.8, selectable: true },
    { id: 'very-low', value: 1, selectable: true },
  ]

  export const UNCERTAINTY_LEVEL_OPTIONS = UNCERTAINTY_LEVEL_RANGES.filter(e => e.selectable);

  export interface Monetary {
    exploitedValue: number;
    exploitedPresent: number;
    totalValue: number;
    presentValue?: number;
    uncertaintyLevel?: number;
    note: string;
  }

  export const normalize = (physical: Physical) => {
    const { totalAssets = 0, normalized } = physical;
    const { min = 0, max = 0 } = normalized ?? {};
    return max > 0 ? (totalAssets - min) / (max - min) : 0;
  }

  export const getUncertaintyLevel = (value: number) => {
    const ranges = UNCERTAINTY_LEVEL_RANGES;
    const _value = Math.round(100 * value) / 100; // avoid 0.6000000000000001 to be wrongly considerate as > 0.6
    return ranges.find(e => _value <= e.value) ?? ranges[0];
  }
}
